$(document).ready(function () {
  let currentSlide = 0;
  let totalSlides = 6;
  
  const leftCarousel = $(".carousel .left-column").slick({
    arrows: false,
    dots: false,
    infinite: false,
    vertical: true,
    verticalSwiping: true,
    speed: 600,
    easing: 'ease-in-out',
    accessibility: false,
    draggable: false,
    swipe: false,
    touchMove: false
  });
  
  const rightCarousel = $(".carousel .right-column").slick({
    arrows: false,
    dots: false,
    infinite: false,
    vertical: true,
    verticalSwiping: true,
    speed: 600,
    easing: 'ease-in-out',
    accessibility: false,
    draggable: false,
    swipe: false,
    touchMove: false,
    initialSlide: totalSlides - 1
  });
  
  function updateProgress(slide) {
    $('.progress-dot').removeClass('active');
    $('.progress-dot').eq(slide).addClass('active');
  }
  
  function goToSlide(slideIndex) {
    if (slideIndex === currentSlide) return;
    
    currentSlide = slideIndex;
    leftCarousel.slick('slickGoTo', slideIndex);
    const rightSlideIndex = totalSlides - 1 - slideIndex;
    rightCarousel.slick('slickGoTo', rightSlideIndex);
    updateProgress(slideIndex);
  }
  
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: [0, 0.1, 0.25, 0.5, 0.75, 1]
  };
  
  const observer = new IntersectionObserver((entries) => {
    let bestEntry = null;
    let highestRatio = 0;
    
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.intersectionRatio > highestRatio) {
        highestRatio = entry.intersectionRatio;
        bestEntry = entry;
      }
    });
    
    if (bestEntry && highestRatio > 0.6) {
      const slideIndex = parseInt(bestEntry.target.dataset.slide);
      goToSlide(slideIndex);
    }
  }, observerOptions);
  
  $('.scroll-trigger').each(function() {
    observer.observe(this);
  });
  
  updateProgress(currentSlide);
  
  setTimeout(() => {
    $('.scroll-hint').fadeOut();
  }, 3000);
});